module.exports = __webpack_public_path__ + "media/images/categories/thinking-ef4f407e08a2450784b24b6a651403f7.png";